// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"2eaf51f0","966":"31d6cfe0"}[chunkId] + ".chunk.js";
};